import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { TranslationKey } from '@/i18n-key';

import i18n from '@/plugins/i18n';

export const useAmelioTranslations = () => {
    const { i18n: i18nInstance, ready } = useTranslation();
    const { language } = i18nInstance;

    // A new `t` for each language, so a consumer that memoises its labels recomputes them.
    const t = useCallback(
        (key: TranslationKey, options?: Record<string, unknown>): string =>
            i18n.t(key, { lng: language, ...options }),
        [language],
    );

    return { t, i18n: i18nInstance, ready };
};
